var trending_banner = (function( $ ) {

	const _init = function() {
		$('.toggle').on('click', handle_toggle_click);
	};

	const handle_toggle_click = function() {
		$('.toggle').removeClass('active');
		$(this).addClass('active');

		const container = $(this).closest('#trending-posts-banner');
		const most_read_posts = container.find('#most-read-posts');
		const latest_ta_posts = container.find('#latest-ta-posts');

		toggle_posts($(this), most_read_posts, latest_ta_posts);
		set_height(most_read_posts, latest_ta_posts);
	};

	const toggle_posts = function(clickedToggle, most_read_posts, latest_ta_posts) {
		if (clickedToggle.hasClass('most-read')) {
			most_read_posts.show();
			latest_ta_posts.hide();
		} else {
			most_read_posts.removeClass('active').hide();
			latest_ta_posts.show();
		}
	};
	const set_height = function(most_read_posts, latest_ta_posts) {
		latest_ta_posts.css('max-height', most_read_posts.outerHeight(true));
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = trending_banner;